export default __webpack_public_path__ + "static/media/WhiteAd.02b4aa18.jpg";